import { useState } from 'react';
import { useDeveloperAccess } from '../DeveloperAccess';

// Wraps every developer page. Asks for the PIN once per session; afterwards
// each developer screen renders straight away because the unlock is shared.
export default function DeveloperGate({ title = 'Developer', children }) {
  const { unlocked, checking, unlock } = useDeveloperAccess();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');

  if (unlocked) return children;

  const submit = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return;
    const result = await unlock(pin.trim());
    if (!result.ok) {
      setError(result.message);
      setPin('');
    }
  };

  return (
    <div style={s.wrap}>
      <form onSubmit={submit} style={s.card}>
        <div style={s.lock}>
          <i className="fa fa-lock" aria-hidden="true" />
        </div>
        <h4 style={s.title}>{title}</h4>
        <p style={s.hint}>
          Enter the developer PIN. One unlock covers every developer page for this session.
        </p>
        <input
          style={s.input}
          type="password"
          inputMode="numeric"
          autoFocus
          value={pin}
          onChange={(e) => {
            setPin(e.target.value);
            setError('');
          }}
          placeholder="Developer PIN"
        />
        {error ? <div style={s.error}>{error}</div> : null}
        <button style={s.button} type="submit" disabled={checking || !pin.trim()}>
          {checking ? 'Checking…' : 'Unlock'}
        </button>
      </form>
    </div>
  );
}

const s = {
  wrap: { display: 'flex', justifyContent: 'center', padding: '60px 16px' },
  card: {
    width: '100%',
    maxWidth: 380,
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 14,
    padding: 26,
    boxShadow: '0 10px 30px rgba(15,23,42,0.06)',
    textAlign: 'center',
  },
  lock: { fontSize: 26, color: '#2563eb', marginBottom: 10 },
  title: { margin: '0 0 6px', fontWeight: 700 },
  hint: { color: '#6b7280', fontSize: 13, lineHeight: 1.5, marginBottom: 16 },
  input: {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: 9,
    padding: '11px 12px',
    fontSize: 16,
    textAlign: 'center',
    letterSpacing: 4,
  },
  error: { color: '#b91c1c', fontSize: 13, marginTop: 10 },
  button: {
    width: '100%',
    marginTop: 14,
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: 9,
    padding: '11px 14px',
    fontWeight: 700,
    cursor: 'pointer',
  },
};
